import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { radius } from '@/styles/Themes/Metrics';
import { cssVars } from '@/styles/Themes/cssVars';
import { Transition } from '@/styles/Themes/KeyFrames';
import Text from '@/styles/Themes/Text';

export const Title = styled.h1`
    font-size: 2.5rem;
    color: ${cssVars.fg_gray1_white};
    margin-bottom: 2rem;
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;

    ${Screen.ipad} {
        grid-gap: 36px;
    }

    ${Screen.desktop} {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr;
        margin: 10px 0 20px;
    }
`;

export const Card = styled.div`
    position: relative;
    background-color: ${cssVars.bg_white_dark3};
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_card_default};
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    border: 1px solid ${cssVars.bg_gray4_dark2};
    ${Screen.ipad} {
        overflow-y: hidden;
    }

    ${Screen.desktop} {
        border: none;
    }

    &:hover {
        box-shadow: ${cssVars.shadow_card_hover};
        ${Transition.normal};
    }
`;
export const AuthorImageWrapper = styled.div`
    padding: 12px;
`;
export const AuthorImage = styled.div`
    position: relative;
    width: 100%;
    max-height: 400px;
    border-radius: ${radius.small};
    overflow: hidden;
    background: ${cssVars.bg_lightBlue_darker};

    span {
        display: block !important;
    }
    image {
        display: block;
    }

    ${Screen.ipad} {
        height: 400px;
    }
`;

export const AuthorContent = styled.div`
    position: relative;
    padding: 24px;
    display: flex;
    flex: 1;
    flex-direction: column;
    z-index: 0;
`;

export const AuthorTitle = styled.h2`
    ${Text.Mobile.heading4.bold}
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.heading4.bold}
    margin: 5px 0;
    ${Screen.ipad} {
        ${Text.Ipad.heading4}
    }
`;

export const AuthorDescription = styled.p`
    color: ${cssVars.fg_gray2_white};
    ${Text.Full.medium.regular}
    margin-bottom: 12px;

    a {
        color: ${cssVars.fg_green_greenLight};
        text-decoration: underline;
        font-weight: 500;
    }

    div {
        ${Text.Full.medium.regular};
    }
    ul {
        padding-left: 10px;
        margin: 0;
    }

    li::marker {
        content: '- ';
    }
`;

export const SocialWrapper = styled.div`
    margin: 12px 0;
`;

export const AuthoButton = styled.a`
    margin-top: auto;
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background: transparent;
    border: 2px solid #03d9b1;
    border-radius: 100px;
    color: #03d9b1;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s ease;
    text-align: center;

    &:hover {
        background: #03d9b1;
        color: white;
    }
`;
